export default __webpack_public_path__ + "static/media/november-banner-mob.e5875b9b.jpg";